import { createFileRoute } from "@tanstack/react-router";

import { AgentHomePage } from "@/features/chat/components/AgentHomePage";

export const Route = createFileRoute("/_authenticated/agent/")({
  component: AgentHomePage,
});
